import { render } from "./allproducts.vue?vue&type=template&id=182324d8&scoped=true"
import script from "./allproducts.vue?vue&type=script&lang=js"
export * from "./allproducts.vue?vue&type=script&lang=js"

import "./allproducts.vue?vue&type=style&index=0&id=182324d8&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-182324d8"]])

export default __exports__